<template>
  <div>
    <el-tabs value="tab_user" type="border-card" v-model="activeName">
      <el-tab-pane label="旅游险" name="tab_user">
        <!--  步骤  -->
        <el-steps :active="active" finish-status="success">
          <el-step title="选择商品"></el-step>
          <el-step title="核保"></el-step>
          <el-step title="待支付"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
        <transition name="fade">
          <!-- 商品列表 -->
          <div v-if="active === 0">
            <div class="scrollable-area product-gallery">
              <el-row :gutter="20" justify="start">
                <el-col
                    :xs="24"
                    :sm="12"
                    :md="8"
                    :lg="6"
                    :xl="4"
                    v-for="product in products"
                    :key="product._id"
                >
                  <div class="product-card" @click="handleCardClick(product)">
                    <img :src="product.image" alt="Product Image" class="product-image"/>
                    <h3 class="product-title">{{ product.name }}</h3>
                    <div class="product-details">
                      <p class="product-price">¥{{ product.extra.premium }}</p>
                      <p class="product-days">有效期{{ product.extra.validDays }}天</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="button-container">
              <el-button type="primary" @click="queryProduct">刷新</el-button>
            </div>
          </div>
          <!-- 商品详情 -->
          <div v-else>
            <div class="scrollable-area" v-if="active === 1">
              <p>商品：{{ selectedProduct.name }} 价格：{{ selectedProduct.extra.premium / 100 }}元</p>
              <el-form :model="form" label-width="120px">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-table :data="form.participants" size="small" style="width: 100%;">
                      <el-table-column prop="type" label="类型" width="100">
                        <template v-slot:="scope">
                          {{ scope.row.type === 'applicant' ? '投保人' : '被保人' }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" label="姓名" width="150">
                        <template v-slot:="scope">
                          <el-input v-model="scope.row.name" placeholder="请输入姓名"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="certi_no" label="证件号码" width="200">
                        <template v-slot:="scope">
                          <el-input v-model="scope.row.certi_no" placeholder="请输入证件号码"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="phone" label="电话" width="150">
                        <template v-slot:="scope">
                          <el-input v-model="scope.row.phone" placeholder="请输入电话"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="email" label="邮箱" width="200">
                        <template v-slot:="scope">
                          <el-input v-model="scope.row.email" placeholder="请输入邮箱"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="action" label="操作" width="100">
                        <template v-slot:="scope">
                          <el-button
                              type="text"
                              @click="removeParticipant(scope.$index)"
                              v-if="scope.row.type !== 'applicant'"
                          >
                            删除
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>

                <!-- 添加被保人按钮 -->
                <el-button type="primary" @click="importFromExcel" style="margin-top: 10px;">导入Excel</el-button>
                <el-button type="primary" @click="addParticipant" style="margin-top: 10px;">添加被保人</el-button>
                <el-button type="primary" @click="heBao" style="margin-top: 10px; margin-left: 10px;">提交
                </el-button>
              </el-form>
            </div>

            <div class="scrollable-area" v-if="active === 2">
              <p>核保完成</p>
              <el-button type="primary" @click="handlePay">去支付</el-button>
            </div>
            <div class="scrollable-area" v-if="active === 3">
              <div id="qrcode-wrapper" ref="qrcodeWrapper" style="text-align: center">
                <!-- 二维码画布 -->
                <canvas ref="qrcodeCanvas"></canvas>
                <p>{{ pay.content }}</p>
                <p>总订单ID：{{ pay.orderPackId }}</p>
              </div>
            </div>
            <div class="scrollable-area" v-if="active === 4">
              <el-alert
                  title="操作成功"
                  type="success"
                  show-icon
              >
              </el-alert>
              <el-table :data="create" size="mini">
                <el-table-column label="订单ID" prop="_id" width="180"/>
                <el-table-column label="支付方式" width="80">
                  <template v-slot:="scope">
                    <div>
                      {{ getPayTypeDesc(scope.row.payType) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="保单号" prop="policyNo" width="200"/>
                <!--                <el-table-column label="产品名字" prop="extra.product.name" width="200"/>-->
                <!--                <el-table-column label="价格" prop="extra.product.extra.premium" width="50"/>-->
                <el-table-column label="总单号" prop="orderPackId" width="200"/>
              </el-table>
            </div>

            <div class="button-container">
              <el-button v-if="[2,3].includes(active)" type="primary" @click="reHeBao">重填信息并核保</el-button>
              <el-button type="primary" @click="cancel">返回商品页</el-button>
            </div>
          </div>
        </transition>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import * as _ from 'lodash';
import QRCode from 'qrcode';
import VueJsonEditor from '@/components/VueJsonEditor'
import {getImageUrl,} from "@/utils";
import {getPayTypeDesc, PaymentState, defaultTimeZone} from '@/utils/constants';
import moment from "moment";

export default {
  components: {QRCode, VueJsonEditor},
  data() {
    return {
      timer: null,
      activeName: 'tab_user',
      // 每次重新查询
      products: [],
      form: this.resetForm(),
      // 选中的商品
      qrData: null,
      selectedProduct: null,
      pre: null,
      pay: null,
      create: null,
      orderFinish: false,
      active: 0,
      getPayTypeDesc,
      defaultTimeZone,
    };
  },
  methods: {
    moment() {
      return moment
    },
    resetForm() {
      return {
        flight_info: {},
        participants: [
          {
            type: 'applicant', // 投保人
            name: '',
            certi_no: '',
            phone: '',
            email: '',
          },
          {
            type: 'insured', // 投保人
            name: '',
            certi_no: '',
            phone: '',
            email: '',
          },
        ],
      }
    },

    importFromExcel() {
      this.$message.info(`暂不支持！！`);
    },

    addParticipant() {
      this.form.participants.push({
        type: 'insured', // 被保人
        name: '',
        certi_no: '',
        phone: '',
        email: '',
      });
    },

    removeParticipant(index) {
      this.form.participants.splice(index, 1);
    },

    queryProduct() {
      this.products = [];
      this.form = this.resetForm();
      let params = {
        limit: 1000,
        offset: 0,
      }
      this.$axios.post('/product/list', params).then(res => {
        this.$message.info('查询商品成功');
        res.product.forEach((item) => {
          item.image = `${getImageUrl()}/${item.baosiId}/${item._id}/list.png`;
          if (item.state === 0 && !!item.extra) {
            // console.log(item._id);
            this.products.push(item);
          }
        })
      }).catch(res => {
      })
    },

    handleCardClick(product) {
      console.log(`selected product: ${product._id}`);
      this.selectedProduct = product;
      this.active = 1;
    },

    cancel() {
      console.log(`cancel selectedProduct: ${this.selectedProduct._id}`);
      this.selectedProduct = null;
      this.orderFinish = false;
      this.active = 0;
      this.pay = null;
      this.create = null;
      this.params = null;
    },

    reHeBao() {
      this.active = 1;
      this.pay = null;
    },

    heBao() {
      const extract_birth_date = (certi_no) => {
        const year = certi_no.substring(6, 10);
        const month = certi_no.substring(10, 12);
        const day = certi_no.substring(12, 14);
        return `${year}-${month}-${day}`;
      };
      const params = {
        productId: this.selectedProduct._id,
        insured: [],
        flightInfo: this.form.flight_info,
      };
      // console.log(JSON.stringify(this.form));
      this.form.participants.forEach((item) => {
        const info = {
          name: item.name,
          certi_type: "01",
          type: "1",
          certi_no: item.certi_no,
          phone: item.phone,
          email: item.email,
          birthday: extract_birth_date(item.certi_no),
        }
        if (item.type === 'applicant') {
          params.applicant = info;
        } else {
          _.assign(info, {
            is_peer: true,
            relation: "01",
          });
          params.insured.push(info);
        }
      })

      // 不要每次都去创建订单
      if (!!this.pre && _.isEqual(this.pre.params, params)) {
        this.$message.info(`核保信息没变！！`);
        this.active = 2;
        return;
      }

      this.$axios.post("/payment/order/pack/create/pre", params)
          .then(resp => {
            if (resp.wrongList.length > 0) {
              // todo：错误的详细日志
              this.$message.error(JSON.stringify(resp.wrongList));
            } else {
              console.log(`create new order: ${resp.orderPackId}`);
              this.pre = {
                params,
                resp,
              }
              this.active = 2;
            }
          })
          .catch(error => {
            console.error(error);
          });
    },

    handlePay() {
      this.createOrder(this.pre.resp.orderPackId);
    },

    showQrCode() {
      this.active = 3;
      this.$nextTick(function () {
        // console.log(`showQrCode: ${JSON.stringify(this.pay)}`);
        const canvas = this.$refs.qrcodeCanvas;
        QRCode.toCanvas(canvas, this.pay.pay.url, {width: 300}, (error) => {
          if (error) console.error(error);
        });
      })
    },

    createOrder(orderPackId) {
      const params = {
        orderPackId,
        payType: 1,
      };
      this.$axios.post("/payment/order/pack/create", params)
          .then(resp => {
            console.log(`createOrder resp: ${JSON.stringify(resp)}`);
            this.pay = {...resp, content: `支付金额：${resp.pay.amount / 100}元`};
            this.showQrCode();
          })
          .catch(error => {
            console.error(error);
          });
    },

    run(self) {
      if (self.$route.path !== '/comm/sale') {
        console.log(self.$route.path);
        return;
      }
      // 订单还没完成
      if (self.selectedProduct && (self.pay && !self.create)) {
        self.queryOrder(self.pay.orderPackId);
      }
    },

    queryOrder(orderPackId) {
      const params = {
        orderPackId,
      }
      this.$axios.post("/payment/order/pack/query", params)
          .then(resp => {
            console.log(`queryOrder: ${JSON.stringify(orderPackId)} state: ${resp.state}`);
            if (resp.state === PaymentState.Finish) {
              this.create = resp.orderList;
              this.orderFinish = true;
              this.active = 4;
            }
          })
          .catch(error => {
            console.error(error);
          });
    },

    handleUpload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const lines = data.split("\n");
        lines.forEach(line => {
          const [name, certi_no] = line.split(",");
          if (name && certi_no) {
            // this.form.insureds.push({
            //   name: name.trim(),
            //   certi_no: certi_no.trim()
            // });
          }
        });
      };
      reader.readAsText(file);
      return false; // 阻止自动上传
    },

  },

  created() {
    this.current_app = this.$store.state.app;
    this.queryProduct();
    this.timer = setInterval(this.run, 2000, this);
  },

  beforeDestroy() {
    this.clearTimer();
  },

  clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  computed: {
    cur_app() {
      return this.$store.state.app;
    }
  },
  watch: {
    $route(to) {
      if (this.current_app === this.$store.state.app) {
        return
      }
    }
  },
};

</script>

<style>
.form-card {
  margin: 20px;
  padding: 20px;
}

.product-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* 在垂直方向上均匀分布 */
  background-color: white;
  border-radius: 5px;
  overflow: hidden;
  text-align: center;
  transition: box-shadow 0.3s, border-color 0.3s;
  border: 2px solid transparent;
  height: 350px; /* 固定高度 */
}

.product-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: red; /* 悬停时红色框 */
}

.product-image {
  width: 100%;
  height: 200px; /* 固定高度，保持比例 */
  object-fit: cover; /* 填充容器 */
}

.product-title {
  font-size: 16px;
  margin: 10px 0;
  flex-grow: 1; /* 填充剩余空间 */
}

.product-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  font-size: 14px;
}

.product-price {
  color: #ff4d4f;
}

.product-days {
  color: #999;
}

.scrollable-area {
  height: 70vh; /* 或者根据你的需要调整为其他固定高度 */
  overflow-y: auto;
}

.button-container {
  display: flex;
  justify-content: flex-end; /* 右对齐 */
  padding: 10px;
}

.el-button {
  margin-right: 10px;
}
</style>
